<template>
  <div class="custom-message_box">
	<div class="custom-message">
		<div class="img_box">
			<img :src="get_imgSrc()"/>
		</div>
		<div class="message_text" :class="messageType == 'success' ? 'success' : 'error'" v-html="message"></div>
	</div>
  </div>
</template>

<script>
export default {
	name: 'GlobalMessage',
	props: {
	  message: {
	    type: String,
	    default: ''
	  },
	  messageType: {
	    type: String,
	    default: ''
	  },
	},
   data() {
		return {
			success_src: 'https://oss-gzh.tozo.com.cn/sunbathing/success_icon.png',
			error_src: 'https://oss-gzh.tozo.com.cn/sunbathing/error_icon.png',
		}
   },
	
	created() {
		
	},
	
	mounted(){
		
	},
	
	methods: {
		get_imgSrc(){
			if(this.messageType == 'success'){
				return this.success_src
			}else{
				return this.error_src
			}
		}
	}
}
</script>

<style lang='less' scoped>
.custom-message_box{
	position: fixed;
	left: 0;
	top: 0;
	z-index: 9999;
	display: flex;
	justify-content: center;
	align-items: center;
	width: 100%;
	height: 100%;
}
.custom-message {
	background-color: rgba(76, 76, 76, 1);
	padding: 15px 20px 23px 20px;
	min-width: 150px;
	max-width: 180px;
	border-radius: 10px;
	text-align: center;
	display: flex;
	justify-content: center;
	flex-direction:column;
	.img_box{
		width: 55px;
		height: 55px;
		margin: auto;
		img{
			width: 100%;
			border-radius: 50%;
		}
	}
	
	.message_text{
		margin-top: 15px;
		font-size: 15px;
		line-height: 22px;
		font-family: PingFang SC-Regular, PingFang SC;
		font-weight: 400;
		color: rgba(255,255,255,0.9);
	}
	.success{
		/* color: green; */
	}
	.error{
		/* color: red; */
	}
}

</style>
